import FormatNumber from '@/filters/FormatNumber'
import { DynamicFormField } from '../../DynamicFormTypes'

interface NumericMask {
  decimal: string
  thousands: string
  prefix: string
  suffix: string
  precision: number
  masked: boolean
}

export function useNumberFormatting() {
  const formatNumberValue = (value: any, field: DynamicFormField): string => {
    const numericValue = parseFloat(value) || 0

    const numericMask: NumericMask = {
      decimal: ('decimal' in field && field.decimal) || ',',
      thousands: ('thousands' in field && field.thousands) || '.',
      prefix: ('prefix' in field && field.prefix) || '',
      suffix: ('suffix' in field && field.suffix) || '',
      precision: 'precision' in field && field.precision !== undefined ? field.precision : 2,
      masked: false
    }

    return FormatNumber.format(numericValue, numericMask)
  }

  return {
    formatNumberValue
  }
}
